module.exports = __webpack_public_path__ + "static/media/star_active.cd3c8651.svg";